import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Page from 'components/page';

import { ContratosEmail } from './ContratosEmail';
import { ContratosPin } from './ContratosPin';
import { ContratosPanel } from './ContratosPanel';
import { useContratos } from './useContratos';

/**
 * Public counterparty contract-validation page (/contratos).
 * Three steps: corporate e-mail -> single-use PIN -> validation panel.
 */
export function Contratos() {
    const { t } = useTranslation('contratos');
    const cv = useContratos();

    const [step, setStep] = React.useState('email'); // email | pin | panel
    const [pendingEmail, setPendingEmail] = React.useState('');

    return (
        <Page.Page name="Contratos" menu={false}>
            {step === 'email' && (
                <ContratosEmail
                    t={t}
                    cv={cv}
                    onSent={email => {
                        setPendingEmail(email);
                        setStep('pin');
                    }}
                />
            )}

            {step === 'pin' && (
                <ContratosPin
                    t={t}
                    cv={cv}
                    email={pendingEmail}
                    onBack={() => setStep('email')}
                    onVerified={() => setStep('panel')}
                />
            )}

            {step === 'panel' && (
                <ContratosPanel
                    t={t}
                    cv={cv}
                    onExpired={() => {
                        cv.reset();
                        setStep('email');
                    }}
                />
            )}
        </Page.Page>
    );
}
export default Contratos;
